import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const fetchWorkflowQuery = gql`
  query fetchWorkflowQuery($id: Long!) {
    workflow(id: $id) {
      name
      workflowType
      labels {
        name
      }
    }
  }
`;

export const useGetJourneyDetails = (id: number) => {
  const { data = {} } = useGraphql(fetchWorkflowQuery, {
    variables: { id },
  });

  return data.workflow || {};
};
